export default function Divider() {
    return (
        <div className="fn_cs_section_divider">
            <div className="divider">
                <span className="short"></span>
                <span className="long"></span>
                <span className="short"></span>
            </div>
        </div>
    )
}